import React, { useEffect, useState } from "react";
import TableRatings from "./TableRatings";
import ToggleButtonGroup from "../../../shared/components/Buttons/ToggleButtonGroup";
import s from "../styles.module.css";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
function Ratings() {
  const handleSelection = (index) => {
    console.log("Selected button index:", index);
  };
  const token = useSelector((state) => state.auth.token);

  const [data, setData] = useState(null);
  const [loadingData, setLoadingData] = useState(false);
  const [loadingError, setLoadingError] = useState(null);

  useEffect(() => {
    const fetchPropertyData = async () => {
      setLoadingData(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/v1/agents/agent-ratings`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        if (!response.ok) {
          const errorMessage = "Ошибка при загрузки данных";
          toast.error(errorMessage);
          setLoadingError(errorMessage);
          setLoadingData(false);
        }
        const data = await response.json();
        setLoadingData(false);
        setData(data);
      } catch (error) {
        setLoadingData(false);
        setLoadingError("Ошибка:", error);
      }
    };
    fetchPropertyData();
  }, [token]);

  if (loadingData) {
    return (
      <div className="loadingContainer">
        <div className="loader"></div>
      </div>
    );
  }
  if (loadingError) {
    return (
      <div className="errorDataBox">
        <p>{loadingError}</p>
      </div>
    );
  }
  return (
    <div className="container">
      <ToggleButtonGroup
        buttons={["Все", "Доступные", "Проданные"]}
        onSelect={handleSelection}
      />
      <div className={s.row}>
        <TableRatings ratings={data} />
        {/* <div className={s.bestBox}>
          <h1>Лучший в этом месяце</h1>
          <img className={s.number} src={number} alt="number" />
          <div className={s.people}>
            <img
              src="https://politics.princeton.edu/sites/default/files/styles/square/public/images/p-5.jpeg?h=87dbaab7&itok=ub6jAL5Q"
              alt=""
            />
            <h2>Каухар Ринатова</h2>
          </div>
        </div> */}
      </div>
    </div>
  );
}

export default Ratings;
